var React = require('react');

function SocialIconTiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3818 0H8.68537V10.8985C8.68537 12.1971 7.64829 13.2638 6.35767 13.2638C5.06705 13.2638 4.02996 12.1971 4.02996 10.8985C4.02996 9.6232 5.04401 8.57969 6.28854 8.53333V5.79711C3.54597 5.84347 1.3335 8.09276 1.3335 10.8985C1.3335 13.7276 3.59207 16 6.38073 16C9.16935 16 11.4279 13.7044 11.4279 10.8985V5.31013C12.442 6.05218 13.6865 6.49276 15.0002 6.51596V3.77971C12.9721 3.71015 11.3818 2.04058 11.3818 0Z","fill":"white"}));
}

SocialIconTiktok.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SocialIconTiktok;

SocialIconTiktok.default = SocialIconTiktok;
